import React from "react";
import { Link, Text } from "@merge-api/merge-javascript-shared";
import { AuditLogRole } from "../../../../../../../models/Entities";
import { PROD_LINKED_ACCOUNT_PATH } from "../../../../../../../router/RouterUtils";

type UserCellProps = {
  role: AuditLogRole;
  name?: string;
  email?: string;
  linkedAccountId?: string;
};

const UserCell = ({ role, name, email, linkedAccountId }: UserCellProps) => {
  if (role === AuditLogRole.END_USER) {
    return (
      <td>
        <div className="flex flex-col">
          <Text variant="h6" className="flex-wrap">
            End user
          </Text>
          {linkedAccountId && (
            <Text variant="sm" className="text-gray-40 flex-wrap">
              <Link target="_blank" href={`${PROD_LINKED_ACCOUNT_PATH}/${linkedAccountId}`}>
                {linkedAccountId}
              </Link>
            </Text>
          )}
        </div>
      </td>
    );
  }

  if (!name) {
    return <td>-</td>;
  }

  return (
    // Actor name + email are user PII and are thus masked at the cell (ph-no-capture cascades to descendants)
    <td className="ph-no-capture">
      <div className="flex flex-col">
        <Text variant="h6" className="flex-wrap">
          {name}
        </Text>
        <Text variant="sm" className="text-gray-40 flex-wrap">
          {email}
        </Text>
      </div>
    </td>
  );
};

export default UserCell;
